/**
 * Which palette a card is drawn in.
 *
 * Colour identifies the SECTION, never the individual metric (Mike,
 * 2026-08-22). Every card inside a section shares one background, one border
 * and one icon colour; only the glyph, the figure and the words differ.
 *
 * This replaced a per-metric scheme with six semantic tones. It looked
 * meaningful and was not: Stalled and Recommended Stop are both `high` severity
 * yet were drawn amber and red, so no reader could infer the rule. Severity
 * still exists and still orders the risk cards — it simply is not painted.
 *
 * There is deliberately no per-metric branch here. If a future card needs its
 * own colour, that is a decision about the colour system, not a line to add.
 */
import type { ReportSection } from '../../api/types'

export type Tone = 'performance' | 'actions' | 'quality'

const BY_SECTION: Record<string, Tone> = {
  pipeline_health: 'performance',
  immediate_actions: 'actions',
  pipeline_quality: 'quality',
}

export function toneFor(sectionKey: ReportSection['key']): Tone {
  return BY_SECTION[sectionKey] ?? 'performance'
}
